import './index.scss';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import LogRocket from 'logrocket';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import axios from "axios";
import {IS_DEV, isProd} from "./utils/env";
import './assets/fonts/marion.ttf';
import './assets/fonts/AvenirLTStd-Book.otf';
import './assets/fonts/Copperplate-Regular.ttf';

// CRA's webpack DefinePlugin replace the exact expression process.env.REACT_APP_API_BASE_URL with the literal string at build. With process?.env?.REACT_APP_API_BASE_URL the AST nodes are OptionalMemberExpression — DefinePlugin won't match, so the string never get inlined. At runtime in the browser process is undefined → expression evaluate to undefined → fallback to /api. Internal site silently break.
axios.defaults.baseURL = IS_DEV ? 'http://localhost/api' : process.env.REACT_APP_API_BASE_URL || '/api';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['X-Client'] = 'fearless-league-website';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// Latest Photo51 app version
axios.defaults.headers.common['X-Version'] = '3.0.31';
axios.defaults.withCredentials = false;

if (isProd()) {
    // Only include logrocket on production to save on recordings.
    LogRocket.init('fearless-league/website-jvkya');
}

const rootElement = document.getElementById('root') as HTMLElement;

const router = createBrowserRouter([
    {
        path: "*",
        element: <App />,
    },
]);

const app = (
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);

// react-snap pre-renders public routes into static HTML at build time.
// When the root element already has children (i.e. we're hydrating a snapshot),
// use hydrateRoot so React attaches event handlers without re-rendering the DOM.
// Fresh page loads (no pre-rendered HTML) fall through to a normal createRoot render.
if (rootElement.hasChildNodes()) {
    ReactDOM.hydrateRoot(rootElement, app);
} else {
    ReactDOM.createRoot(rootElement).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
